import * as React from "react";
import Typography from "@mui/material/Typography";
import LinearProgress from "@mui/material/LinearProgress";
import Box from "@mui/material/Box";

function LinearProgressWithLabel(props) {
  return (
    <Box className="mt-4 ml-5" sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "95%", mr: 1 }}>
        <Typography variant="body2" sx={{ color: "white", fontSize: "12px" }}>
          {props.label}
        </Typography>

        <LinearProgress
          variant="determinate"
          {...props}
          sx={{
            height: 5,
            borderRadius: 2,
            backgroundColor: "#191923", // color del "track"
            "& .MuiLinearProgress-bar": {
              backgroundColor: "#ffc107", // color del progreso
            },
          }}
        />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" sx={{ color: "#8c8c8e", marginLeft: "-30px", marginBottom: "5px" }}>
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

export default LinearProgressWithLabel;
